module.exports = __webpack_public_path__ + "img/shape-metal_aa-gold@2x.17b78c3d.png";